import React from 'react';
import { Info } from 'lucide-react';

const DISCLAIMER_TEXT = `Sponsiq analyzes publicly available creator content to detect brand sponsorships. Brand names displayed on this platform are derived from publicly available sponsorship mentions and are shown for informational purposes only. The presence of a brand on Sponsiq does not imply any partnership, endorsement, or affiliation with Sponsiq.`;

// Inline disclaimer - compact version for cards and sections
export const BrandDisclaimerInline = ({ className = '' }) => (
  <p className={`text-xs text-slate-500 leading-relaxed ${className}`} data-testid="brand-disclaimer-inline">
    <span className="font-medium text-slate-600">Brand Disclaimer:</span> {DISCLAIMER_TEXT}
  </p>
);

// Card disclaimer - styled as a standalone card
export const BrandDisclaimerCard = ({ className = '' }) => (
  <div className={`bg-slate-50 border border-slate-200 rounded-lg p-4 ${className}`} data-testid="brand-disclaimer-card">
    <div className="flex items-start gap-3">
      <Info className="w-4 h-4 text-slate-500 mt-0.5 flex-shrink-0" />
      <div>
        <h4 className="text-sm font-semibold text-slate-700 mb-1">Brand Disclaimer</h4>
        <p className="text-xs text-slate-600 leading-relaxed">
          {DISCLAIMER_TEXT}
        </p>
      </div>
    </div>
  </div>
);

// Section disclaimer - for dedicated disclaimer sections
export const BrandDisclaimerSection = ({ className = '' }) => (
  <section className={`py-8 bg-white border-t border-slate-200 ${className}`} data-testid="brand-disclaimer-section">
    <div className="max-w-4xl mx-auto px-6">
      <div className="bg-slate-50 border border-slate-200 rounded-lg p-6">
        <h3 className="text-sm font-semibold text-slate-900 mb-2">Brand Disclaimer</h3>
        <p className="text-xs text-slate-600 leading-relaxed">
          {DISCLAIMER_TEXT}
        </p>
      </div>
    </div>
  </section>
);

// Default export is the card version
export default BrandDisclaimerCard;
